
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }
  canActivate() {
    return this.authService.checkIsAdmin().pipe(
      map((isAdmin: boolean) => {
        if (isAdmin) {
          return true;
        }
        this.router.navigateByUrl("/fooldal");
        return false;
      }),
      catchError(() => {
        this.router.navigateByUrl("/fooldal");
        return of(false);
      })
    );
  }

}
;
